import axios from 'axios';
import { useState, useCallback, useEffect } from 'react'
import apiBase from 'src/config/apiBase';

const useHttpRequest = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    const cancelToken = axios.CancelToken
    const source = cancelToken.source()

    const sendRequest = useCallback(
        async (
            url,
            method,
            headers,
            body
        ) => {
            setIsLoading(true)

            try {
                const { data: responseData } = await apiBase({
                    url: `${apiBase.defaults.baseURL}${url}`,
                    method,
                    headers: { ...apiBase.defaults.headers, ...headers },
                    data: body,
                    cancelToken: source.token,
                })

                return responseData
            } catch (error) {
                setError(error)
                throw error
            } finally {
                setIsLoading(false)
            }
        },
        []
    )

    const clearError = () => setError('')

    useEffect(() => {
        return () => {
            source.cancel('axios request cancelled')
        }
    }, [])

    return { isLoading, error, sendRequest, clearError }
}

export { useHttpRequest }